import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { setFormType } from "../../auth/authSlice";

const ResetPasswordTrigger = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  useEffect(() => {
    dispatch(setFormType("resetPassword"));
    navigate(`/?token=${token}`, { replace: true });
  }, [dispatch, navigate, token]);

  return null;
};

export default ResetPasswordTrigger;
